import React from 'react';
import cx from 'classnames';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MuiChip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  entry: {
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: theme.palette.grey[400],
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },
  chip: {
    marginRight: theme.spacing(1),
  },
  dark: {
    backgroundColor: theme.palette.grey[400],
  },
}));

const distanceText = distance => {
  switch (distance) {
    case 0:
      return 'Ihre Suche stimmt mit der Postleitzahl überein.';
    default:
      return `ca. ${distance.toFixed(0)} km von Ihrer Suche entfernt`;
  }
  return null;
};

const fpkTag = tag => {
  let val;
  if (tag === 'x') val = 'Fachstudio Pelletkaminofen';
  return val;
};

const pfbTag = tag => {
  let val;
  if (tag === 'x') val = 'Pelletfachbetrieb';
  return val;
};

const Chip = ({ isDark, ...props }) => {
  const classes = useStyles();
  return (
    <MuiChip
      className={cx(classes.chip, { [classes.dark]: isDark })}
      {...props}
    />
  );
};

const Entry = props => {
  const {
    name,
    email,
    web,
    tel,
    place,
    zip,
    street,
    distance,
    support,
    pfb,
    fpk,
    tags,
  } = props;
  const classes = useStyles();
  const fpkTagValue = fpkTag(fpk);
  const pfbTagValue = pfbTag(pfb);
  const distText = distanceText(distance);
  return (
    <Box className={classes.entry}>
      <Box>
        {distText && <Typography variant="body2">{distText}</Typography>}
        <Typography variant="h5">{name}</Typography>
        <Box mb={0.5}>
          {fpkTagValue && <Chip isDark label={fpkTagValue} />}
          {pfbTagValue && <Chip isDark label={pfbTagValue} />}
          {tags.map(tag => (
            <Chip key={tag} label={tag} />
          ))}
        </Box>
        {support && (
          <Typography variant="body1" gutterBottom>
            <b>{support}</b>
          </Typography>
        )}
      </Box>
      <Box display="flex" flexDirection="column">
        <Typography variant="body1">{street}</Typography>
        <Typography variant="body1">
          {zip} {place}
        </Typography>
        <Typography
          component="a"
          color="primary"
          variant="body1"
          href={`tel:${tel}`}
        >
          {tel}
        </Typography>
        <Typography
          component="a"
          color="primary"
          variant="body1"
          href={`mailto:${email}`}
        >
          {email}
        </Typography>
        <Typography
          component="a"
          color="primary"
          variant="body1"
          href={`http://${web}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {web}
        </Typography>
      </Box>
    </Box>
  );
};

export default Entry;
